module.exports = __webpack_public_path__ + "static/media/Forest-Trails.195175fd.pdf";